var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecurringSolid = function SvgRecurringSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 5H5c-.667 0-2 .4-2 2v12c0 .667.4 2 2 2h7.302c-2.212-5.3-.57-10.5 5.198-10.5H19V7c0-.667-.4-2-2-2h-1.25v2a.75.75 0 0 1-1.5 0V5h-6.5v2a.75.75 0 0 1-1.5 0V5Zm-2.5 5a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H4.5a.75.75 0 0 1-.75-.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.667 15.91a3.375 3.375 0 0 0-6.459-.833M14 13.41v1.667h1.667M14 18a3.375 3.375 0 0 0 6.458.833m.209 1.667v-1.667H19M15 3v2M7 3v1.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRecurringSolid;